
import BForm from 'Src/js/components/blain-form/BForm.vue';
import BSelect from 'Src/js/components/blain-form/BSelect.vue';
import bugsnagClient from 'JS/global/bugsnag';
import StepWrapper from './StepWrapper.vue';
import VehicleAttributeSelector from './form/VehicleAttributeSelector.vue';
import WithImmutableObjectValue from 'JS/mixins/WithImmutableObjectValue';
import { Component, Inject, Mixins, Prop } from 'vue-property-decorator';
import { delay } from 'JS/utilities/promise';
import { TrimStep as ITrimStep } from '../types/steps';
import { IVehicleLookupService } from 'Src/js/services/automotive/VehicleLookupService';

@Component({
	name: 'TrimStep',
	components: {
		BForm,
		BSelect,
		StepWrapper,
		VehicleAttributeSelector,
	}
})
class TrimStep extends Mixins(WithImmutableObjectValue<ITrimStep['data']>(() => ({ availableTrims: null, trim: null }))) {
	@Inject('VehicleLookupService')
	_vehicleLookupService: IVehicleLookupService;

	@Prop({ type: String, required: true })
	year: string;

	@Prop({ type: String, required: true })
	make: string;

	@Prop({ type: String, required: true })
	model: string;

	@Prop({ type: Boolean })
	loading: boolean;

	loadingState: 'loading' | 'error' | 'idle' = 'idle';

	get canContinue() {
		return typeof this.trim === 'string' && this.trim.length > 0 || this.trim === false;
	}

	get trims() {
		const availableTrims = (this.availableTrims ?? []) as (string | false)[];
		return availableTrims?.length
			? availableTrims.concat(false)
			: availableTrims;
	}

	async mounted() {
		if (this.availableTrims.length) {
			return;
		}

		this.loadingState = 'loading';

		try {
			this.availableTrims = await delay(this._vehicleLookupService.getTireTrims(this.year, this.make, this.model), 750);
			this.loadingState = 'idle';
		} catch (e) {
			bugsnagClient.notify(e);
			this.loadingState = 'error';
		}
	}
}

export default TrimStep;
